export default class ThemeHelper {
  static isTouchDevice() {
    return window.matchMedia("(pointer: coarse)").matches;
  }

  static HEX2RGB(colour: string, alpha: number = 1) {
    const hex = colour.replace("#", "");

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
  }

  static calculateColorGradient = (
    startColor: string, // = '#FF0000',
    endColor: string, // = '#00FF00',
    ratio: number
  ) => {
    const hex = (color: number) => {
      const colorString = color.toString(16);
      return colorString.length === 1 ? `0${colorString}` : colorString;
    };
    const color1 = startColor.replace("#", "");
    const color2 = endColor.replace("#", "");

    const r: number = Math.ceil(
      parseInt(color2.substring(0, 2), 16) * ratio +
        parseInt(color1.substring(0, 2), 16) * (1 - ratio)
    );
    const g: number = Math.ceil(
      parseInt(color2.substring(2, 4), 16) * ratio +
        parseInt(color1.substring(2, 4), 16) * (1 - ratio)
    );
    const b: number = Math.ceil(
      parseInt(color2.substring(4, 6), 16) * ratio +
        parseInt(color1.substring(4, 6), 16) * (1 - ratio)
    );

    return "#" + hex(r) + hex(g) + hex(b);
  };

  static isIphone = () => {
    return !!navigator.userAgent.match(/iPhone/i);
  };

  static isPwa = () => {
    return ["fullscreen", "standalone", "minimal-ui"].some(
      (displayMode) =>
        window.matchMedia("(display-mode: " + displayMode + ")").matches
    );
  };

  static isGEiPhoneX = () => {
    return window.devicePixelRatio >= 3 && window.screen.height >= 812;
  };
}
